import React from "react";
import { useParams } from "react-router-dom";
import FeaturesData from "./Features";
import "../../Styles/features.css";
import { useNavigate } from "react-router-dom";

const FeaturePage = () => {
  const { featureSlug } = useParams();
  const data = FeaturesData[featureSlug];
  const navigate = useNavigate();

  if (!data) return <h2>Feature Not Found</h2>;

  const onclickcontatctus = () => {
    navigate("/contact-us");
    window.scrollTo(0, 0);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="features-drop-down-main-app-coontianer">
      <div
        className="features-dropdown-banner-section"
        style={{ backgroundColor: data.backgroundColor || "#fff" }}
      >
        <div className="width-wrapper">
          <div className="i-section-1-wrap">
            <div className="i-section-1-1" data-aos="fade-right">
              <h1>{data.title}</h1>
              <h3>{data.subtitle}</h3>
              <p>{data.description}</p>
            </div>
            <div className="i-section-1-2">
              {data.bannerimage.endsWith(".mp4") ? (
                <video
                  key={data.bannerimage} // ✅ Force re-render on route change
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="video-1"
                  preload="auto"
                >
                  <source src={data.bannerimage} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={data.bannerimage}
                  alt={data.title}
                  className="banner-image"
                />
              )}
              {/* <video
                key={data.bannerimage} 
                autoPlay
                loop
                muted
                playsInline
                className="video-1"
                preload="auto"
              >
                <source src={data.bannerimage} type="video/mp4" />
                Your browser does not support the video tag.
              </video> */}
            </div>
          </div>

          {/* <div className="banner-content-wrapper">
            <div
              className="banner-content"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <h1>{data.title}</h1>
              <h3>{data.subtitle}</h3>
              <p>{data.description}</p>
            </div>
           <img
              src={data.bannerimage}
              alt={data.title}
              data-aos="fade-left"
              data-aos-delay="200"
            /> 

            <video
              autoPlay
              loop
              muted
              playsInline
              className="video-1"
              preload="auto"
            >
              <source src={data.bannerimage} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div> */}
        </div>
      </div>

      <div
        className="features-wrapper"
        style={{ backgroundColor: data.featuresWrapperBg || "#f8f7ff" }}
      >
        <div className="width-wrapper">
          {data.sections.map((each, i) => (
            <div className="features-wraper-1" key={i}>
              {i % 2 === 0 ? (
                <div className="wrap-1-card">
                  <img
                    src={each.image}
                    alt={each.heading}
                    data-aos="fade-right"
                    data-aos-delay="200"
                  />
                  <div
                    className="f-wrap-content"
                    data-aos="fade-left"
                    data-aos-delay="200"
                  >
                    <h1>{each.heading}</h1>
                    <p>{each.subtext}</p>
                    <div className="bullet-1">
                      <ul>
                        {each.points?.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="wrap-1-card">
                  <div
                    className="f-wrap-content"
                    data-aos="fade-right"
                    data-aos-delay="200"
                  >
                    <h1>{each.heading}</h1>
                    <p>{each.subtext}</p>
                    <div className="bullet-1">
                      <ul>
                        {each.points?.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <img
                    src={each.image}
                    alt={each.heading}
                    data-aos="fade-left"
                    data-aos-delay="200"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="features-wrapper-2-1 ">
        <div className="width-wrapper">
          {data.section2?.map((each, i) => (
            <div className="features-wraper-1" key={i}>
              <div className="wrap-1-card-2" data-aos="zoom-in-up">
                <div className="f-wrap-content-2">
                  <h1>{each.heading}</h1>
                  <p>{each.text}</p>
                </div>
                <img src={each.image} alt={each.heading} className="d-d" />
                <img src={each.image2} alt={each.heading} className="m-d" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* third section */}
      <div className="feaured-wrapper-3">
        <div className="width-wrapper">
          {data.thirdsection.map((each, i) => (
            <div key={i} className="features-warp-3" data-aos="zoom-in-up">
              <h2>{each.heading}</h2>
              <p>{each.text}</p>
              <button type="button" onClick={onclickcontatctus}>
                {each.button}
                <span className="arrow">→</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturePage;
